// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"6a906e8b","117":"b6658ae9","154":"7a08c274","266":"82d78c18","311":"7dbc95cf","381":"44f4069e","453":"ee24ddb7","724":"746a1644"}[chunkId] + ".chunk.js";
};